const en_purch_invoice = {
    "": "purchase invoice",
    add: "create purchase invoice",
    detail: "purchase invoice detail",
    edit: "edit purchase invoice",
    payment: "purchase invoice payment list",

    label: {
        file: "invoice proof",
        date_create: "invoice creation date",
        po_list_title: "PO list",
    },

    message: {
        cancel_title: "Are you sure you want to cancel the purchase invoice?",
        cancel_text: "Enter the reason for canceling the purchase invoice.",
    },

    error: {
        create: "Failed to create the purchase invoice.",
        edit: "Failed to update the purchase invoice.",
        cancel: "Failed to cancel the purchase invoice.",
    },

    success: {
        create: "Purchase invoice created successfully.",
        edit: "Purchase invoice updated successfully.",
        cancel: "Purchase invoice canceled successfully.",
    },
}

export default en_purch_invoice;